import merge from "lodash/merge";
import { isNeoBrand } from "@/helpers";
import BaseEnUs from "./en-US.json";
import NeoEnUs from "./neo/en-US.json";

const mergedEnUs = merge({}, BaseEnUs, isNeoBrand() ? NeoEnUs : {});

export default mergedEnUs;
